/**
 * Maps a landing banner from the API to the home banner contract.
 * Pure function — no side effects, no dependencies.
 *
 * Preserves navigation fields used by `useBannerNavigation`:
 * `url`, `urlPackage`, `esConsulta`, `detalle`, `id`.
 *
 * @param {object} banner - Raw API banner object
 * @param {string} [banner.titulo] - Banner title
 * @param {string} [banner.descripcion] - Banner description
 * @param {string} [banner.imagen] - Desktop image URL
 * @param {string} [banner.imagenMobile] - Mobile image URL
 * @param {string} [banner.precio] - Manual price
 * @param {string} [banner.url] - Target URL
 * @param {string} [banner.urlPackage] - Package link (takes priority over url)
 * @returns {object} Mapped banner with standardized keys
 */
export function mapLandingBannerToHomeBanner(banner) {
  return {
    ...banner,
    title: banner.titulo || '',
    description: banner.descripcion || '',
    imageUrl: banner.imagen || '',
    imagenMobile: banner.imagenMobile || '',
    manualPrice: banner.precio || '',
    url: banner.url || '',
    urlPackage: banner.urlPackage || '',
  };
}
